<div class="dialog-root">
  <div class="dialog-header">
    <div class="left">
      <mat-icon>edit</mat-icon>
      <div class="title-block">
        <span class="title">{{ 'AdminQuestionnaireEditQuestionTitle' | translate }}</span>
        <span class="subtitle">{{ 'AdminQuestionnaireEditQuestionSubtitle' | translate }}</span>
      </div>
    </div>
    <button mat-icon-button [attr.aria-label]="'AdminQuestionnaireClose' | translate" class="close-btn" (click)="closeCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body">
    <app-question [question]="data.question" [context]="context" [questionnaireAnswer]="qa$" [user]="data.user" (changeAnswer)="onChange($event)"></app-question>
  </div>

  <div class="dialog-footer">
    <div class="buttons">
      <button class="def-button alt" (click)="closeCancel()">{{ 'AdminQuestionnaireCancel' | translate }}</button>
      <button class="def-button primary" (click)="saveAndClose()">{{ 'AdminQuestionnaireSave' | translate }}</button>
    </div>
  </div>
</div>
